import { createRouter, createWebHistory } from 'vue-router'
import Home from './components/Home.vue'
import Patches from './components/Patches.vue'
import Settings from './components/Settings.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/patches', component: Patches },
  { path: '/settings', component: Settings }
]

const router = createRouter({
  linkActiveClass: 'tab-active',
  history: createWebHistory(),
  routes,
})

export default router
